import { render } from "./FlexImage.vue?vue&type=template&id=cf4a5c9c"
import script from "./FlexImage.vue?vue&type=script&lang=js"
export * from "./FlexImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__